import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./Nav.css";

export default function Nav() {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  const { pathname } = useLocation();

  // add class depending on path
  const alignmentClass = pathname === "/" ? "nav-home" : "nav-other";

  return (
    <nav className={`nav ${alignmentClass} ${open ? "open" : ""}`}>
      <button
        className="nav-toggle"
        onClick={() => setOpen(!open)}
        aria-label="Menu"
      >
        <span />
        <span />
        <span />
      </button>
      <ul className="nav-list" onClick={close}>
        <li>
          <NavLink to="/" end className="nav-link">
            Home
          </NavLink>
        </li>
        <li>
          <NavLink to="/about" className="nav-link">
            About
          </NavLink>
        </li>
        <li>
          <NavLink to="/cv" className="nav-link">
            CV
          </NavLink>
        </li>
        <li>
          <NavLink to="/research" className="nav-link">
            Research
          </NavLink>
        </li>
        <li>
          <NavLink to="/teaching" className="nav-link">
            Teaching
          </NavLink>
        </li>
        <li>
          <NavLink to="/contact" className="nav-link">
            Contact
          </NavLink>
        </li>
      </ul>
    </nav>
  );
}
